import compose, { isComposeFactory } from './compose';
import createDestroyable from './bases/createDestroyable';
import createEvented from './bases/createEvented';
import createStateful from './bases/createStateful';

export {
	compose,
	isComposeFactory,
	createDestroyable,
	createEvented,
	createStateful
};
